/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useState} from 'react';
import PageBox from "../../layouts/pageBox";
import {ReactComponent as Search} from "../../assets/img/icons/search-box.svg";
import {ReactComponent as Close} from "../../assets/img/forms/close.svg";
import {ReactComponent as Car} from "../../assets/img/dismantlers/car.svg";
import {ReactComponent as Parts} from "../../assets/img/dismantlers/parts.svg";
import dismantler from "../../assets/img/desmantler.jpg";
import pin from "../../assets/img/pin.png";
import {Link, useParams} from "react-router-dom";
import {useEffect} from "react";
import Loader from "../../elements/loader";
import useAxiosJTW from "../../Hooks/useAxiosJTW";
import {useTranslation} from "react-i18next";
import { GoogleMap, Marker, InfoWindow, LoadScript } from '@react-google-maps/api';
import SEO from "../../components/SEO";

const Dismantlers = () => {

    const [dismantlers, setDismantlers] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [isLoading, setLoading] = useState(true);

    const [mapCenter, setMapCenter] = useState({ lat: 0, lng: 0 });
    const [activeMarker, setActiveMarker] = useState(null);

    const axiosJWT = useAxiosJTW();
    const { t, i18n } = useTranslation();
    const params = useParams();

    const data = {
        title: 'Dismantlers',
        subtitle: `${t('dismantlers.subtitle')}`
    };

    const getdismantlers = (signal) => {
        axiosJWT.post('api/getdismantlers',null, {signal}).then( (response) => {
            if(response.status === 200){
                setDismantlers(response.data);

                const _arr = [];
                for(let i = 0; i < response.data.length; ++i ){
                    if(response.data[i].map_data.position[0].lat != 0 && response.data[i].map_data.position[0].lng){
                        _arr.push(response.data[i].map_data.position[0]);
                    }
                }

                getCenter(_arr);

                setLoading(false);
            }
        } ).catch((error) => {
            console.log(error);
        });

    }

    useEffect(() => {
        const controller = new AbortController();
        const signal= controller.signal;

        getdismantlers(signal);

        return () => {controller.abort();}
    }, [params]);

    useEffect(() => {
        //otan allazei to search ksana kentraro
        const _arr = [];
        for(let i = 0; i < dismantlers.filter(filterNames).length; ++i ){
            if(dismantlers.filter(filterNames)[i].map_data.position[0].lat != 0 && dismantlers.filter(filterNames)[i].map_data.position[0].lng){
                _arr.push(dismantlers.filter(filterNames)[i].map_data.position[0]);
            }
        }

        if(_arr.length > 0){
            getCenter(_arr);
        }


    }, [searchValue]);

    const getCenter = (_arr) =>{
        const sumLat = _arr.reduce((total, position) => total + position.lat, 0);
        const sumLng = _arr.reduce((total, position) => total + position.lng, 0);
        const avgLat = sumLat / _arr.length;
        const avgLng = sumLng / _arr.length;

        setMapCenter({ lat: avgLat, lng: avgLng });
    }

    const filterNames = ({ company }) => {
        return company.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1;
    };

    const handleActiveMarker = (marker) => {
        if (marker === activeMarker) {
            return;
        }
        setActiveMarker(marker);
    };


    return (
        <PageBox data={data}>
            <SEO
                title={t('meta_title.dismantlers')}
                description={t('meta_description.dismantlers')}
            />
            <div className='page-body'>
                <div className='dismantlers-row'>
                    <div className='dismantlers-sidebar'>

                        <div className='search-box search-box--small'>
                            <div className='search-box__row'>
                                <div className='search-box__icon'>
                                    <Search/>
                                </div>
                                <div className='search-box__element'>
                                    <input className='form-control' placeholder={t('dismantlers.dismantlersSearch')} onChange={ (e) => {setSearchValue(e.target.value);} } value={searchValue}/>
                                </div>
                            </div>
                        </div>

                        {/*<div className='dismantlers-filters'>*/}
                        {/*    <div className="form-row">*/}
                        {/*        <div className="form-group col">*/}
                        {/*            <label htmlFor="Dismantlers">Show me:</label>*/}
                        {/*            <select id="Dismantlers" className="form-control">*/}
                        {/*                <option>Dismantlers</option>*/}
                        {/*                <option>One</option>*/}
                        {/*                <option>Two</option>*/}
                        {/*                <option>Three</option>*/}
                        {/*            </select>*/}
                        {/*        </div>*/}
                        {/*        <div className="form-group col">*/}
                        {/*            <label htmlFor="Country">Country</label>*/}
                        {/*            <select id="Country" className="form-control">*/}
                        {/*                <option>- select - </option>*/}
                        {/*                <option>One</option>*/}
                        {/*                <option>Two</option>*/}
                        {/*                <option>Three</option>*/}
                        {/*            </select>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        <div className='dismantlers pt-4'>

                            {isLoading ? (
                                <div style={{ paddingTop: '30px', textAlign : 'center', margin: '0 auto' }}><Loader/></div>
                            ) : (
                                dismantlers.filter(filterNames).map( (dismantler, index) => {
                                    if (dismantler.map_data.position[0].lat != 0){
                                        return(
                                            <div onClick={() => handleActiveMarker(dismantler.merchant_id)} className='dismantlersItem' key={index}>
                                                <div className='dismantlersItem__img'>{dismantler.logo && <img src={dismantler.logo} alt={dismantler.company} /> }</div>
                                                <div className='dismantlersItem__content'>
                                                    <div className='dismantlersItem__title text--title'>{dismantler.company}</div>
                                                    <div className='dismantlersItem__description'></div>
                                                    {/*<div className='dismantlersItem__footer opened'>Open til 6pm</div>*/}
                                                </div>
                                            </div>
                                        )
                                    }
                                    return (
                                        <Link to={`/${i18n.language}/mini-site/cars/${dismantler.merchant_id}/${dismantler.merchant_slug}`} className='dismantlersItem' key={index}>
                                            <div className='dismantlersItem__img'><img src={dismantler.logo} alt={dismantler.company} /> </div>
                                            <div className='dismantlersItem__content'>
                                                <div className='dismantlersItem__title text--title'>{dismantler.company}</div>
                                                <div className='dismantlersItem__description'></div>
                                                {/*<div className='dismantlersItem__footer opened'>Open til 6pm</div>*/}
                                            </div>
                                        </Link>
                                    )
                                } )
                            )}
                        </div>

                    </div>
                    <div className='dismantlers-content'>
                        <div className='dismantlers-mapWrap'>

                            <LoadScript googleMapsApiKey={`${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`} language={i18n.language}>
                                <GoogleMap
                                    mapContainerStyle={{width: '100%', height: '100%'}}
                                    center={mapCenter}
                                    zoom={8}
                                >
                                    {dismantlers.filter(filterNames).map(( dismantler, index ) => {
                                        if(dismantler.map_data.position[0].lat != 0 ){
                                            return(
                                                <Marker
                                                    key={dismantler.merchant_id}
                                                    position={dismantler.map_data.position[0]}
                                                    onClick={() => handleActiveMarker(dismantler.merchant_id)}
                                                    // icon={{
                                                    //     url: pin,
                                                    //     url: dismantler.logo,
                                                    //     scaledSize: { width: 128, height: 128 }
                                                    // }}
                                                >
                                                    {activeMarker === dismantler.merchant_id ? (
                                                        <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                                                            <div className='MapItem'>
                                                                <div className='MapItem__inner'>
                                                                    <div className='MapItem__header'>
                                                                        <div className='MapItem__img'>{dismantler.logo && <img src={dismantler.logo} alt='dismantler' />}</div>
                                                                        <div className='MapItem__content'>
                                                                            <div className='MapItem__title text--title'>{dismantler.company}</div>
                                                                            <div className='MapItem__description'>{dismantler.address}, {dismantler.postalcode}, {dismantler.city_title}, {dismantler.country_title}</div>
                                                                            {/*<div className='MapItem__status opened'>Open til 6pm</div>*/}
                                                                            <div className='MapItem__reviews'></div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='MapItem__body'>
                                                                        <div className='MapItem__row'>
                                                                            <div className='itemCount'>
                                                                                <div className='itemCount__icon'><Car/></div>
                                                                                <div className='itemCount__content'>
                                                                                    <div className='itemCount__num text--title'>{dismantler.total_cars}</div>
                                                                                    <div className='itemCount__title small-text'>{t('dismantlers.cars')}</div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='itemCount'>
                                                                                <div className='itemCount__icon'><Parts/></div>
                                                                                <div className='itemCount__content'>
                                                                                    <div className='itemCount__num text--title'>{dismantler.total_parts}</div>
                                                                                    <div className='itemCount__title small-text'>{t('dismantlers.Parts')}</div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {/*<div className='MapItem__note small-text'>Usually responds at 24 hours </div>*/}
                                                                    </div>
                                                                    <div className='MapItem__footer'>
                                                                        <Link to={`/${i18n.language}/mini-site/cars/${dismantler.merchant_id}/${dismantler.merchant_slug}`} className='btn btn-primary btn--MapItem'>{t('dismantlers.VisitMinisite')}</Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </InfoWindow>
                                                    ) : null}
                                                </Marker>
                                            )
                                        }
                                    })}
                                </GoogleMap>
                            </LoadScript>

                        </div>
                    </div>
                </div>
            </div>
        </PageBox>
    );
};

export default Dismantlers;
